import { empty } from 'ant-design-vue-admin-x';
import moment from 'moment';

export default {
  methods: {
    /** 默认搜索条件时间 */
    handleDefaultDate () {
      let end = moment(new Date());
      let start = moment().subtract(1, 'months');
      const date = [start, end];
      empty.$emit('setSearchValue', { [`${this.$route.name}/createDate`]: date });

      this.$nextTick(() => {
        this.$refs.table.$refs.search.handleSearch();
      });
    }
  }
};
